import { uiLocale } from "@/i18n";

/** Format "YYYY-MM" to a short month name in the active admin language */
export function formatMonth(month: string): string {
  const parts = month.split("-");
  if (parts.length >= 2) {
    const monthIndex = parseInt(parts[1], 10) - 1;
    if (monthIndex >= 0 && monthIndex <= 11) {
      return new Date(2000, monthIndex, 1).toLocaleDateString(uiLocale(), { month: "short" });
    }
    return parts[1];
  }
  return month;
}

/** Format a date string as short date: "Mar 15" / "15. bře" */
export function formatShortDate(date: string): string {
  return new Date(date).toLocaleDateString(uiLocale(), {
    day: "numeric",
    month: "short",
  });
}

export { default as StatCard } from "./StatCard";
export { default as RevenueChart } from "./RevenueChart";
export { default as OrdersChart } from "./OrdersChart";
export { default as FunnelChart } from "./FunnelChart";
export { default as DestinationPieChart } from "./DestinationPieChart";
export { default as OccupancyTable } from "./OccupancyTable";
export { default as GuideStats } from "./GuideStats";
export { default as CustomerStats } from "./CustomerStats";
export { default as MarketingStats } from "./MarketingStats";
export { default as TrafficChart } from "./TrafficChart";
export { default as AdsPerformance } from "./AdsPerformance";
